import { useDayjs } from '#imports'
import useLayeredContent from './useLayeredContent'
import type { PressArticle } from '../../utils/press-config'

export function useContentPress() {
    const { queryAll, queryBySlug } = useLayeredContent()
    const dayjs = useDayjs()

    /**
     * Get press articles sorted by publishAt date descending (newest first).
     */
    async function getPressArticles() {
        const all = await queryAll<PressArticle>('press/posts')
        return all.sort((a, b) => {
            const dateA = a.publishAt ? dayjs(a.publishAt).valueOf() : 0
            const dateB = b.publishAt ? dayjs(b.publishAt).valueOf() : 0
            return dateB - dateA
        })
    }

    async function getPressArticleBySlug(slug: string) {
        return await queryBySlug<PressArticle>('press/posts', slug)
    }

    return { getPressArticles, getPressArticleBySlug }
}
